<template>
    <div class="container">
        <div class="row justify-content-center my-3">
            <div class="col-12 col-lg-9">

                <h3>Season 1 (2022)</h3>
                <div>
                    <sup>February 23, 2022</sup>
                    <ul>
                        <li><strong>New</strong> Kilo 141 stats</li>
                        <li><strong>New</strong> PPSh-41 stats</li>
                        <li>AK-47 stats updated</li>
                        <li>AK-47 (5.45) stats updated</li>
                    </ul>
                </div>
            
                <h3>Season 1 (2022)</h3>
                <div>
                    <sup>January 30, 2022</sup>
                    <ul>
                        <li><strong>New</strong> Kilo 141 stats</li>
                        <li><strong>New</strong> PPSh 41 stats</li>
                    </ul>
                </div>
            
                <h3>Season 10 (2021)</h3>
                <div>
                    <sup>November 21, 2021</sup>
                    <ul>
                        <li><strong>New</strong> CBR4 stats</li>
                        <li><strong>New</strong> Type 25 (SP) stats</li>
                        <li>Type 25 stats updated</li>
                        <li>MX9 stats updated</li>
                        <li>MW11 stats updated</li>
                        <li>
                            Full Patch Notes:
                            <ul>
                                <li><a href="https://www.reddit.com/r/CallOfDutyMobile/comments/qv0m4i/call_of_duty_mobile_nov_15th_community_update/">CODM Subreddit</a></li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <h3>Season 9 (2021)</h3>
                <div>
                    <sup>October 21, 2021</sup>
                    <ul>
                        <li><strong>New</strong> Swordfish stats</li>
                        <li><strong>New</strong> Decreased damage profile of MX9 (BR only)</li>
                        <li>
                            <strong>New</strong> Rytec (base and thermite&explosive ammo) stats added
                            <ul><li>Note: Thermite and Explosive ammo still not included for TTK&STK calculations at this moment.</li></ul>
                        </li>
                        <li>KN-44 stats updated</li>
                        <li>CR-56 AMAX (M67) stats updated</li>
                        <li>UL736 stats updated</li>
                        <li>Chopper stats updated</li>
                        <li>
                            Full Patch Notes:
                            <ul>
                                <li><a href="https://www.reddit.com/r/CallOfDutyMobile/comments/qceq4z/call_of_duty_mobile_october_20th_community_update/">CODM Subreddit</a></li>
                                <li><a href="https://www.facebook.com/codm/posts/4041780152594467?__tn__=K-R">Garena CODM FB</a></li>
                            </ul>
                        </li>
                    </ul>
                </div>
                
                <h3>Season 8 (2021)</h3>
                <div>
                    <sup>October 13, 2021</sup>
                    <ul>
                        <li>Added options for including missed shots to TTK&STK.</li>
                    </ul>
                </div>
                <div>
                    <sup>October 7, 2021</sup>
                    <ul>
                        <li>Added options for Long Range Mod (BR)</li>
                    </ul>
                </div>
                <div>
                    <sup>September 28, 2021</sup>
                    <ul>
                        <li>Updated Clan War Node Calculator</li>
                    </ul>
                </div>
                <div>
                    <sup>September 23, 2021</sup>
                    <ul>
                        <li>
                            <strong>NEW: </strong>
                            Battle Royale HP System (no more vests)
                        </li>
                        <li>Added M13 stats</li>
                        <li>
                            PDW-57
                            <ul>
                                <li>Changed head multiplier from 1.1 to 1.2</li>
                                <li>Added x1.1 arms multipler</li>
                            </ul>
                        </li>
                        <li>
                            HG 40
                            <ul>
                                <li>Added x1.1 chest multipler</li>
                                <li>Changed legs multiplier from 0.9 to 0.95</li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <h3>Season 7 (2021)</h3>
                <div>
                    <sup>September 7, 2021</sup>
                    <ul>
                        <li>Added AK-47 (5.45mm) stats</li>
                        <li>Added Man-O-War stats</li>
                        <li>Added DR-H and DR-H (OTM) stats</li>
                        <li>Added CR-56 (M67) stats</li>
                        <li>Added S36 stats</li>
                        <li>Added UL736 stats</li>
                        <li>Added Chicom stats</li>
                        <li>Added HG 40 stats</li>
                        <li>Added Pharo stats</li>
                        <li>Added GKS stats</li>
                        <li>Added MX9 (LC) stats</li>
                        <li>Added Cordite stats</li>
                        <li>Added QQ9 (10mm) stats</li>
                        <li>Added J358 stats</li>
                        <li>Added MW11 stats</li>
                        <li>Added .50 GS stats</li>
                        <li>Fixed HVK-30 damage and hitbox stats</li>
                        <li>Fixed CR-56 AMAX damage and hitbox stats</li>
                    </ul>
                </div>
                
                <div>
                    <sup>August 26, 2021</sup>
                    <ul>
                        <li>Added Hades stats</li>
                        <li>
                            LK24
                            <ul>
                                <li>Added x1.1 chest multiplier</li>
                            </ul>
                        </li>
                        <li>
                            Holger 26
                            <ul>
                                <li>2nd range drop off decreased</li>
                            </ul>
                        </li>
                        <li>
                            RUS-79U
                            <ul>
                                <li>Added x1.1 chest multiplier</li>
                            </ul>
                        </li>
                        <li>
                            Fennec
                            <ul>
                                <li>Added x1.05 stomach multiplier</li>
                                <li>Added x0.8 legs multiplier</li>
                            </ul>
                        </li>
                        <li>Fixed some incorrect stats</li>
                    </ul>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
